import { useState, useEffect } from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import ImageAnotation from 'core/components/image-anotation/ImageAnotation';
import { createAPI, updateAssetannotationInfo, deleteAPI, getAssetannotationInfoByAssetidAPI } from 'api/AssetannotationAPI';
import { addAnnotations, deleteAnnotationById } from 'store/slice/AppSlice';

export default function AnnotateAssetActionImpl() {
    const dispatch = useDispatch();
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const {annotationMode} = useSelector((state) => state.appslice);

    const getArrowInsertionObject = (commentObj) =>{
        console.log("getArrowInsertionObject=>"+JSON.stringify(commentObj));
        return {
            assetid: productObj.qaassetid,
            annotationtype: "arrow",
            xposition: commentObj.start.x,
            yposition: commentObj.start.y,
            title: Array.isArray(commentObj.points) ? commentObj.points.join(',') : commentObj.points,
            annotationstatus: 0,
        };
    }
    const getInsertionObject = (commentObj) =>{
        return {
            assetid: productObj.qaassetid,
            title: commentObj.text,
            xposition: commentObj.x,
            yposition: commentObj.y,
            width: commentObj.width,
            height: commentObj.height,
            annotationtype: commentObj.type,
            annotationstatus: 0,
            annotationid: commentObj.commentId
        }
    }
    const addAnnotation = (commentObj) => {
        let payload = {};
        if (commentObj.type === 'arrow') {
            payload = getArrowInsertionObject(commentObj);
        } 
        else if (commentObj.type === 'highlight' || commentObj.type === 'rect') {
            payload = getInsertionObject(commentObj);
        } 

        createAPI(payload,
            (response) => {
                if (commentObj.type === 'arrow')
                dispatch(addAnnotations(transformArrowCommentObject(response)));
                else{
                    commentObj.id = response.id;
                    commentObj.commentId = response.id;
                    dispatch(addAnnotations(commentObj));
                }
                    
            },
            (error) => {
                console.error("Error creating annotation =>" + JSON.stringify(error));
            }
        )
    }
    const deleteAnnotation = (annotationObj) => {
        console.log("Deleting Comment =>" + JSON.stringify(annotationObj));
        console.log("annotationObj.id=>"+annotationObj.id);
        if (annotationObj.id!==undefined && annotationObj.id!==null) {
            deleteAPI(annotationObj.id, (apiResponse)=>{
             console.log("Deleted Comment =>" + JSON.stringify(apiResponse));
            dispatch(deleteAnnotationById(annotationObj.id));
        })
        } 
    }
    const transformArrowCommentObject = (annotationObj) => {
    return {
      id: annotationObj.id,
      commentId: annotationObj.commentId,
      type: annotationObj.annotationtype,
      points: annotationObj.title.split(',').map(Number),
      start: { x: annotationObj.xposition, y: annotationObj.yposition },
      text: ''
    };
  };

    return (
        <Box sx={{ width: '100%', height: '100%', minHeight: 0 }}>
            <ImageAnotation
                imageUrl={productObj.qaassetpath}
                viewportHeight="100%"
                onInjectObject={(object) => addAnnotation(object)}
                onDeleteObject={(object) => deleteAnnotation(object)}
                onEditObject={(object) => console.log("Edited object:", object)}
                mode={annotationMode}
            />
        </Box>
    )
}
